var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { showError, translate } from "@js/common/helpers";
import { Form } from "./Form";
import { List } from "./List";
import { Global } from "./Global";
import { useRating } from "../hooks/useRating";
import { useEffect, useState } from "react";
import { CollectionRating } from "../../types";
import { collectionRatingApi } from "../api";
import { GlobalModal } from "../../modals/GlobalModal";
var CollectionRatingApp = function () {
    var _a = useState([]), ratings = _a[0], setRatings = _a[1];
    var _b = useState(false), isConnectedUserRated = _b[0], setIsConnectedUserRated = _b[1];
    var _c = useState(0), enabledRatingsCount = _c[0], setEnabledRatingsCount = _c[1];
    var _d = useState(0.0), globalRating = _d[0], setGlobalRating = _d[1];
    var _e = useState(1), currentPage = _e[0], setCurrentPage = _e[1];
    var _f = useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(false), isLoadingMore = _g[0], setIsLoadingMore = _g[1];
    var _h = useState(null), user = _h[0], setUser = _h[1];
    var _j = useState(false), isCommentPresent = _j[0], setIsCommentPresent = _j[1];
    var _k = useState(), showGlobalModal = _k[0], setShowGlobalModal = _k[1];
    var _l = useRating(), getRatingOverview = _l.getRatingOverview, getUser = _l.getUser, getCurrentCollectionSlug = _l.getCurrentCollectionSlug;
    useEffect(function () {
        fetchRatingOverview();
    }, []);
    useEffect(function () {
        var fetchConnectedUserVoted = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, userHasRated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getUser()];
                    case 1:
                        data = _a.sent();
                        if (data['logged'] === true) {
                            userHasRated = ratings === null || ratings === void 0 ? void 0 : ratings.some(function (rating) { return data['uuid'] === rating.userUuid; });
                            setIsConnectedUserRated(userHasRated);
                        }
                        setUser(data);
                        setIsLoading(false);
                        return [2];
                }
            });
        }); };
        fetchConnectedUserVoted();
    }, [ratings]);
    var onChargeMore = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextPage, ratingOverview, newRatings_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingMore(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    nextPage = currentPage + 1;
                    return [4, collectionRatingApi.show(getCurrentCollectionSlug(), currentPage * 10)];
                case 2:
                    ratingOverview = _a.sent();
                    if (ratingOverview) {
                        newRatings_1 = ratingOverview.ratings.map(function (data) {
                            return CollectionRating.createFromApi(data);
                        });
                        setRatings(function (prevRatings) { return __spreadArray(__spreadArray([], prevRatings || [], true), newRatings_1, true); });
                        setCurrentPage(nextPage);
                        setIsLoadingMore(false);
                    }
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    showError('collection_rating.form.error.global');
                    setIsLoadingMore(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var fetchRatingOverview = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ratingOverview, newRatings;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getRatingOverview()];
                case 1:
                    ratingOverview = _a.sent();
                    if (ratingOverview) {
                        if (ratingOverview['ratings_count'] <= 0 && ratingOverview['ratings'] === undefined) {
                            setRatings([]);
                            setEnabledRatingsCount(0);
                            setGlobalRating(0);
                            return [2];
                        }
                        newRatings = ratingOverview['ratings'].map(function (data) {
                            return CollectionRating.createFromApi(data);
                        });
                        setRatings(newRatings);
                        setEnabledRatingsCount(ratingOverview['ratings_count']);
                        setGlobalRating(ratingOverview['global_rating'].toFixed(1));
                    }
                    return [2];
            }
        });
    }); };
    var handleAfterRatingCreated = function (comment) {
        if (comment.trim().length > 0) {
            setIsCommentPresent(!!comment);
        }
        setShowGlobalModal(true);
        setIsConnectedUserRated(true);
        fetchRatingOverview();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, translate('collection_rating.title')),
        isLoading
            ?
                React.createElement("div", { className: "spinner" })
            : React.createElement(React.Fragment, null,
                globalRating > 3 && React.createElement(Global, { enabledRatingsCount: enabledRatingsCount, globalRating: globalRating }),
                (user && isConnectedUserRated === false) &&
                    React.createElement(Form, { afterRatingCreated: handleAfterRatingCreated, user: user, enabledRatingsCount: enabledRatingsCount }),
                (user && ((ratings === null || ratings === void 0 ? void 0 : ratings.length) > 0 || enabledRatingsCount > 0)) && React.createElement(List, { ratings: ratings, user: user, afterRatingChange: fetchRatingOverview }),
                enabledRatingsCount > ratings.length && (isLoadingMore
                    ? React.createElement("div", { className: "spinner" })
                    : React.createElement("button", { onClick: onChargeMore, className: "btn flex-center charge-more" }, translate('collection_rating.list.action.load_more'))),
                showGlobalModal && React.createElement(GlobalModal, { isCommentPresent: isCommentPresent }))));
};
export { CollectionRatingApp };
